import { render, staticRenderFns } from "./chooseStyle.vue?vue&type=template&id=cffa4d1a&"
import script from "./chooseStyle.vue?vue&type=script&lang=ts&"
export * from "./chooseStyle.vue?vue&type=script&lang=ts&"
import style0 from "./chooseStyle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports